import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { VersionDropdown } from './VersionDropdown';

export const rehydrator: RehydratorFunction = async (domNode) => {
  const props: React.ComponentProps<
    typeof VersionDropdown
  > = elementAttributesToProps(domNode);

  return Promise.resolve(<VersionDropdown {...props} />);
};

export default rehydrator;
